var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-header img-cover",style:(_vm.aStyle)},[(_vm.role)?_c('div',{staticClass:"role-select img-cover",style:({
      backgroundImage: `url(${_vm.role.rolePath || _vm.defaultRoleImage}`,

      top: `${_vm.$unit(_vm.role.top)}`,
      right: `${_vm.$unit(_vm.role.right)}`
    }),on:{"click":_vm.onSelectRole}},[_c('p',{style:({
        fontSize: `${_vm.$unit(_vm.role.fontSize)}`,
        color: `${_vm.role.fontColor}`
      })},[_vm._v(" "+_vm._s(_vm.userInfo?.role_name || '选择角色')+" ")])]):_vm._e(),(_vm.download && _vm.download.btnSwitch)?_c('div',{staticClass:"btn-header img-cover",style:({
      backgroundImage: `url(${_vm.download.btnPath || _vm.defaultBtnImage}`,
      bottom: `${_vm.$unit(_vm.download.bottom)}`
    }),on:{"click":function($event){return _vm.jump(_vm.download.jumpPath)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }